import type { AppLocale } from '@/urls'
import dayjs from 'dayjs'
import 'dayjs/locale/en-gb'
import 'dayjs/locale/nb'
import 'dayjs/locale/nn'

dayjs.locale('nb')

// dayjs.locale() er global og deles mellom forespørsler på serveren. Språk settes derfor per dato-instans.
const dayjsLocale: Record<AppLocale, string> = { nb: 'nb', nn: 'nn', en: 'en-gb' }

// Engelsk skriver "10 February", ikke "10. February".
const langDatoFormat: Record<AppLocale, string> = { nb: 'D. MMMM YYYY', nn: 'D. MMMM YYYY', en: 'D MMMM YYYY' }

export const formatDate = (data?: string | number | null) => {
    //2020-11-03 -> 03.11.2020 (norsk datoformat)
    //2020-11-03T15:37:38 -> 03.11.2020

    return data ? dayjs(data, ['YYYY-MM-DD', 'YYYY-MM-DDTHH:mm:ss']).format('DD.MM.YYYY') : null
}

export const formatDateText = (data?: string | number | null, locale: AppLocale = 'nb') => {
    //2020-11-03 -> 3. november 2020
    //2020-11-03 -> 3 November 2020 (en)

    return data ? dayjs(data, ['YYYY-MM-DD', 'YYYY-MM-DDTHH:mm:ss']).locale(dayjsLocale[locale]).format(langDatoFormat[locale]) : null
}

export const formatDatePeriode = (fra: string | number | null, til: string | number | null, format?: string) => {
    //2020-11-03 -> 03.11.2020 (norsk datoformat)
    //2020-11-03T15:37:38 -> 03.11.2020
    const datoFra = fra ? dayjs(fra, ['YYYY-MM-DD', "'YYYY-MM", 'YYYY-MM-DDTHH:mm:ss'], true).format(format || 'DD.MM.YYYY') : null
    const datoTil = til ? dayjs(til, ['YYYY-MM-DD', "'YYYY-MM", 'YYYY-MM-DDTHH:mm:ss'], true).format(format || 'DD.MM.YYYY') : null

    // Hardt mellomrom foran bindestreken, ellers kan streken havne alene på en linje ved liten bredde.
    return !datoFra && !datoTil ? null : `${datoFra || ''}\u00a0- ${datoTil || ''}`
}

export const formatDateMonth = (data?: string | number | null, locale: AppLocale = 'nb') => {
    //2020-11 -> november 2020
    //2020-11 -> November 2020 (en)

    return data ? dayjs(data, ['YYYY-MM-DD', "'YYYY-MM", 'YYYY-MM-DDTHH:mm:ss']).locale(dayjsLocale[locale]).format('MMMM YYYY') : null
}

export const formatTimestamp = (data?: string | number | null) => {
    //2020-11-03 -> 03.11.2020 (norsk datoformat)
    //2020-11-03T15:37:38 -> 03.11.2020

    return data ? dayjs(data, ['YYYY-MM-DD', 'YYYY-MM-DDTHH:mm:ss']).format('DD.MM.YYYY HH:mm') : null
}
